/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u45m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running a 45-minute deliberate-practice session on one specific skill.`)
};

const es_timer_u45m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realizar una sesión de práctica deliberada de 45 minutos en una habilidad específica.`)
};

const de_timer_u45m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine 45-minütige Session gezielten Übens an einer bestimmten Fähigkeit absolvieren.`)
};

const nl_timer_u45m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een sessie van 45 minuten doelgerichte oefening draaien op één specifieke vaardigheid.`)
};

const fr_timer_u45m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effectuer une session de pratique délibérée de 45 minutes sur une compétence précise.`)
};

const it_timer_u45m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fare una sessione di pratica intenzionale di 45 minuti su un'abilità specifica.`)
};

const pt_br2_timer_u45m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer uma sessão de prática deliberada de 45 minutos em uma habilidade específica.`)
};

const pt_timer_u45m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer uma sessão de prática deliberada de 45 minutos numa competência específica.`)
};

const ja_timer_u45m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1つの特定のスキルについて45分間の意図的な練習セッションを行う。`)
};

const zh_timer_u45m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`针对某一具体技能进行45分钟的刻意练习。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u45m_use2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u45m_use2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u45m_use2", locale)
	if (locale === "en") return en_timer_u45m_use2(inputs)
	if (locale === "es") return es_timer_u45m_use2(inputs)
	if (locale === "de") return de_timer_u45m_use2(inputs)
	if (locale === "nl") return nl_timer_u45m_use2(inputs)
	if (locale === "fr") return fr_timer_u45m_use2(inputs)
	if (locale === "it") return it_timer_u45m_use2(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u45m_use2(inputs)
	if (locale === "pt") return pt_timer_u45m_use2(inputs)
	if (locale === "ja") return ja_timer_u45m_use2(inputs)
	return zh_timer_u45m_use2(inputs)
};